import React from 'react';
import { Video } from '../Video/Video';
import './RHBlock.scss';

export const RHVideo = ({ node }) => {
    return (
        <section className="rh__block accent video">
            <Video
                inputs={{
                    videoUrl:
                        node.relationships.field_remote_video_url
                            ?.field_media_oembed_video,
                    name: node.relationships?.field_remote_video_url?.name,
                }}
            />
        </section>
    );
};
